import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ADD_ADDRESS: "Legg til ny adresse",
      ADDRESS_ADDED: "Adressen ble lagt til",
      ERROR_ADDING_ADDRESS: "Det skjedde en feil ved å legge til adressen",
      ADD_ADDRESS_TITLE: "Ny adresse",
    },
    se: {
      ADD_ADDRESS: "Lägg till ny adress",
      ADDRESS_ADDED: "Adressen har lagts till",
      ERROR_ADDING_ADDRESS: "Ett fel uppstod när adressen skulle läggas till",
      ADD_ADDRESS_TITLE: "Ny adress",
    },
    dk: {
      ADD_ADDRESS: "Tilføj ny adresse",
      ADDRESS_ADDED: "Adressen er blevet tilføjet",
      ERROR_ADDING_ADDRESS: "Der skete en fejl ved tilføjelse af adressen",
      ADD_ADDRESS_TITLE: "Ny adresse",
    },
  } as const
)[language];
